var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuction3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6475 17.3428H1.65195C0.740017 17.3428 0 18.0827 0 18.9948V21.9987H14.2994V18.9948C14.2994 18.0827 13.5594 17.3428 12.6475 17.3428Z",
    fill: "#737A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7035 17.5754L11.6664 7.53822L13.6051 5.603C13.9248 5.88488 14.4163 5.8711 14.7188 5.56863C15.0351 5.24897 15.0351 4.73677 14.7188 4.41711L10.539 0.240719C10.2227 -0.0789376 9.70714 -0.0789376 9.39093 0.240719C9.07128 0.556974 9.07128 1.07258 9.39093 1.38879L9.35656 1.35441L4.04924 6.65824L4.08361 6.69602C3.76736 6.37636 3.25175 6.37636 2.93554 6.69602C2.61589 7.01227 2.61589 7.52788 2.93554 7.84413L7.11194 12.0239C7.43159 12.3402 7.9472 12.3402 8.26345 12.0239C8.57971 11.7043 8.57971 11.1921 8.26345 10.8725L8.29783 10.9068L10.2365 8.97157L20.2701 19.0053C20.6654 19.4006 21.3082 19.4006 21.7035 19.0053C22.0988 18.61 22.0988 17.9706 21.7035 17.5754Z",
    fill: "#737A91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction3);
export default __webpack_public_path__ + "static/media/auction3.ddc8400a.svg";
export { ForwardRef as ReactComponent };